/**
 * Staff Schedule Models
 * Used for managing recurring weekly schedules for staff members
 */

export interface StaffSchedule {
  scheduleID: number;
  userID: number;
  companyID: number;
  branchID: number;
  dayOfWeek: number; // 0=Sunday, 1=Monday, ... 6=Saturday
  startTime: string; // "HH:mm:ss" format
  endTime: string;   // "HH:mm:ss" format
  isActive: boolean;
  effectiveFrom?: Date;
  effectiveTo?: Date;
  notes?: string;

  // Audit
  addedOn?: Date;
  addedBy?: number;
  updatedOn?: Date;
  updatedBy?: number;

  // Joined properties
  firstName?: string;
  lastName?: string;
  staffName?: string;
  branchName?: string;
  workDate?: Date;
}

export interface StaffScheduleEntry {
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  isActive: boolean;
  notes?: string;
}

export interface StaffScheduleBulkSaveModel {
  userID: number;
  companyID: number;
  branchID: number;
  schedules: StaffScheduleEntry[];
}

// Request params
export interface GetStaffScheduleParams {
  scheduleID?: number;
  userID?: number;
  companyID?: number;
  branchID?: number;
  dayOfWeek?: number;
  isActive?: boolean;
  offSetRows?: number;
  nextRows?: number;
  sortExpression?: string;
}

export interface GetScheduleForDateParams {
  companyID: number;
  branchID?: number;
  workDate: Date | string;
}

export interface InsertStaffScheduleParams {
  userID: number;
  companyID: number;
  branchID: number;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  isActive?: boolean;
  effectiveFrom?: Date;
  effectiveTo?: Date;
  notes?: string;
}

export interface UpdateStaffScheduleParams {
  scheduleID: number;
  startTime: string;
  endTime: string;
  isActive: boolean;
  effectiveFrom?: Date;
  effectiveTo?: Date;
  notes?: string;
}

// Day of week helper
export const DaysOfWeek = [
  { value: 0, label: 'Sunday', shortLabel: 'Sun' },
  { value: 1, label: 'Monday', shortLabel: 'Mon' },
  { value: 2, label: 'Tuesday', shortLabel: 'Tue' },
  { value: 3, label: 'Wednesday', shortLabel: 'Wed' },
  { value: 4, label: 'Thursday', shortLabel: 'Thu' },
  { value: 5, label: 'Friday', shortLabel: 'Fri' },
  { value: 6, label: 'Saturday', shortLabel: 'Sat' }
];

export function getDayOfWeekLabel(dayOfWeek: number): string {
  return DaysOfWeek.find(d => d.value === dayOfWeek)?.label || '';
}

export function getDayOfWeekShortLabel(dayOfWeek: number): string {
  return DaysOfWeek.find(d => d.value === dayOfWeek)?.shortLabel || '';
}
